import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

// Global font styles
const globalStyles = document.createElement('style');
globalStyles.innerHTML = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
  
  *:not(svg):not(svg *) {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif !important;
  }
  
  body, html {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  /* Preserve logo fonts */
  .logo-text, .logo-masters, .logo-path, .logo-masters-small, .logo-path-small, .masters-text, .path-text {
    font-family: inherit !important;
  }
`;
document.head.appendChild(globalStyles);

// Intercept all fetch calls — dispatch 'auth:expired' on any 401 so App can redirect to login
const _fetch = window.fetch;
window.fetch = async (...args) => {
  const response = await _fetch(...args);
  if (response.status === 401) {
    window.dispatchEvent(new Event('auth:expired'));
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </BrowserRouter>
);